export const SUBMIT_SEARCH_REINDEX = {
  REQUEST: "SUBMIT_SEARCH_REINDEX_REQUEST",
  SUCCESS: "SUBMIT_SEARCH_REINDEX_SUCCESS",
  FAILURE: "SUBMIT_SEARCH_REINDEX_FAILURE",
};

export interface SubmitSearchReindexAction {
  type: typeof SUBMIT_SEARCH_REINDEX.REQUEST;
}
